import BaseMonitoring from '@powerednow/shared/modules/monitoring/Base';

declare let Deft: any;
declare let Utilities: any;
declare let NetworkError: any;
declare let LogUtils: any;

const debugFactory = require('@powerednow/shared/modules/debug');

const SyncManagerMonitorDebug = debugFactory('monitoring:SyncManager');

export default class SyncManagerMonitor extends BaseMonitoring {
    private stuckSyncThreshold = 60 * 5 * 1000;

    private lastRecordRemoveTimestamp: number = undefined;

    private currentSyncErrorReported: boolean = false;

    private readonly service: any;

    constructor(service) {
        super();
        this.service = service;
    }

    protected async sendErrorMessage(message, details): Promise<void> {
        await LogUtils.logError('SyncManagerMonitor', message, details, 8, '');
    }

    startMonitoring() {
        super.startMonitoring();
        if (this.service) {
            this.service.on('queue_update', this.onSyncManagerQueueUpdated, this);
        }
    }

    stopMonitoring() {
        super.stopMonitoring();
        if (this.service) {
            this.service.un('queue_update', this.onSyncManagerQueueUpdated);
        }
    }

    onSyncManagerQueueUpdated(newLength, operationType) {
        if (operationType === this.service.self.SYNC_RECORD_REMOVED) {
            this.recordRemoveOperation();
        }
        this.currentSyncErrorReported = false;
    }

    async isServiceHealthy() {
        if (this.service._records.length === 0) {
            this.lastRecordRemoveTimestamp = undefined;
            return true;
        }

        if (!this.lastRecordRemoveTimestamp) {
            this.lastRecordRemoveTimestamp = new Date().getTime();
        }

        const currentTime = new Date().getTime();
        if ((currentTime - this.lastRecordRemoveTimestamp) > this.stuckSyncThreshold) {
            try {
                await Deft.Injector.resolve('apiService').checkVersion(Utilities.getVersion());
            } catch (error) {
                if (error instanceof NetworkError) {
                    return true;
                }
            }
            return false;
        }
        return true;
    }

    recordRemoveOperation() {
        this.lastRecordRemoveTimestamp = new Date().getTime();
    }

    async handleServiceFailure() {
        super.handleServiceFailure('Stuck sync', { records: this.service._records });
        this.currentSyncErrorReported = true;
    }
}
